export default __webpack_public_path__ + "static/media/usap-sanctioned-logo.282a14f8.png";